var _circle, _circle2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBigPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 58,
    cy: 58,
    r: 58,
    fill: "#FF6019"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 58,
    r: 47,
    fill: "#FF6019"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_133:580)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1904 46.0105C50.8594 45.154 49.1081 46.1096 49.1081 47.6924V69.6063C49.1081 71.1832 50.8478 72.1398 52.1793 71.2952L69.3294 60.4174C70.563 59.635 70.5688 57.8371 69.3405 57.0466L52.1904 46.0105Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_133:580"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36.8378,
    height: 36.8378,
    fill: "white",
    transform: "translate(38.946 40.2162)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigPlayIcon);
export default __webpack_public_path__ + "static/media/BigPlayIcon.b20dadac.svg";
export { ForwardRef as ReactComponent };